#import "@/components/common/CraftAssetFragment.gql"

fragment ArticleChapterFragment on articleChapter_Entry {
  id
  typeHandle
  heading
  summaryTitle
  boxRight
  image {
    ...CraftAssetFragment
  }
}
